<template>
  <div class="auth-page">
    <FormAuth />
    <WindowError v-if="warningModal" />
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { computed } from 'vue'

import FormAuth from '@/components/blocks/FormAuth.vue'
import WindowError from '@/components/modals/WindowError.vue'

export default {
  name: 'AuthView',
  components: {
    FormAuth,
    WindowError
  },
  setup () {
    const store = useStore()

    const warningModal = computed(() => {
      return store.getters.getWarningModal
    })

    return {
      warningModal
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-image: url('@/assets/gifs/presintation.gif');
  background-size: cover;
  // background-repeat: no-repeat;
}
</style>
